import style from './style.css';

const ImageComponent = ({ url, isMerchantPageVersion }) => {
  return (
    <div
      className={`${
        isMerchantPageVersion
          ? style.stepImageComponentMerchantPage
          : style.stepImageComponent
      }`}>
      <img src={url} alt='screen-image' />
    </div>
  );
};

export default ImageComponent;



// WEBPACK FOOTER //
// ./routes/program-landing-page/components/bic-steps/steps-image/image-component/index.js